module.exports = __webpack_public_path__ + "static/media/mobile-app.6b3f799e.png";